export default "__VITE_ASSET__CsDJVT5$__"